import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const SEOTextModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "seo-text" */
            './'
        )
    ),
    componentName: 'SEOText',
    placeholder: {
        placeholderType: 'Carousel',
        size: 'md',
    },
});
export default SEOTextModule;
